<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-food-fork-drink</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.food') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <v-divider vertical  style="margin: 0 10px 0 10px;"/>
      <template>
        <span style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px;">{{ name }}</span>     
        <!-- <v-btn-toggle
          v-model="icon" 
          @change="handleChangeIsModified"
        >
          <v-btn :value="'mdi-information'" @click="content.Icon = 'mdi-information'" text>
            <v-icon>mdi-information</v-icon>
          </v-btn>
          <v-btn :value="'mdi-alert'" @click="content.Icon = 'mdi-alert'" text>
            <v-icon>mdi-alert</v-icon>
          </v-btn>
          <v-btn :value="'mdi-help-circle'" @click="content.Icon = 'mdi-help-circle'" text>
            <v-icon>mdi-help-circle</v-icon>
          </v-btn>
          <v-btn :value="'mdi-check-circle'" @click="content.Icon = 'mdi-check-circle'" text>
            <v-icon>mdi-check-circle</v-icon>
          </v-btn>
          <v-btn :value="'mdi-email'" @click="content.Icon = 'mdi-email'" text>
            <v-icon>mdi-email</v-icon>
          </v-btn>
          <v-btn :value="'mdi-clock'" @click="content.Icon = 'mdi-clock'" text>
            <v-icon>mdi-clock</v-icon>
          </v-btn>
           <v-btn :value="''" @click="content.Icon = ''" text>
             <v-icon style="opacity: 0.2">mdi-cancel</v-icon>
          </v-btn>
        </v-btn-toggle> -->
      </template>
    </v-toolbar>
    <translate
      v-show="!collapseContent"
      v-model="content.FoodName"
      :languages="languages"
      :label="$t('food.name')"
      @input="handleChangeIsModified"
      style="padding: 0 10px 0 10px;"
    />
    <translate
      v-show="!collapseContent"
      v-model="content.FoodIngredients"
      :languages="languages"
      :label="$t('food.ingredients')"
      type="textArea"
      @input="handleChangeIsModified"
      style="padding: 0 10px 0 10px;"
    />
    <v-layout wrap v-show="!collapseContent">
      <v-flex xs12>
        <v-text-field
          v-model="content.FoodPrice"
          :label="$t('food.price')"
          hideDetails
          @input="handleChangeIsModified"
        />
      </v-flex>
      <v-flex xs3>
        <v-checkbox
          v-model="content.FoodVegan"
          :color="enterpriseColor"
          :label="$t(`food.vegan`)"
          :value="content.FoodVegan"
        />
      </v-flex>
      <v-flex xs3>
        <v-checkbox
          v-model="content.FoodVegetarian"
          :color="enterpriseColor"
          :label="$t(`food.vegetarian`)"
          :value="content.FoodVegetarian"
        />
      </v-flex>
      <v-flex xs3>
        <v-checkbox
          v-model="content.FoodNew"
          :color="enterpriseColor"
          :label="$t(`food.new`)"
          :value="content.FoodNew"
        />
      </v-flex>
      <v-flex xs3>
        <v-checkbox
          v-model="content.FoodRecommended"
          :color="enterpriseColor"
          :label="$t(`food.recommended`)"
          :value="content.FoodRecommended"
        />
      </v-flex>
      <v-flex xs2>
        <v-checkbox
          v-model="content.FoodSlowFood"
          :color="enterpriseColor"
          label="Slow food"
          :value="content.FoodSlowFood"
        />
      </v-flex>
      <v-flex xs12>
        <translate
          v-model="content.FoodNote"
          :languages="languages"
          :label="$t('food.note')"
          @input="handleChangeIsModified"
          style="padding: 0 10px 0 10px;"
        />
      </v-flex>
    </v-layout>
    <allergens
      v-show="!collapseContent"
      v-model="content.FoodAllergens"
    />
    <select-image
      v-show="!collapseContent"
      v-model="content.FoodImage"
      :isFullWidth="true"
      :enterpriseID="enterpriseID"
      :imageOld='content.FoodImage'
      :imageWidth="600"
      :imageHeight="600"
      :aspectRatio="1/1"
      @input="handleChangeIsModified"
      style="margin-left:0px;margin-top:15px;margin-right: 0px;"
      width="100px"
    />
    <v-expansion-panels focusable style="margin-top: 20px">
      <food-drink-extras-form 
        v-if="showExtras"
        :content="content"
        :locale="locale"
        :onChange="handleChangeExtraConfigLocal"
      />
    </v-expansion-panels>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  import apiDishOrders from '@/services/apiDishOrders'
  import Translate from '@/components/Translate'
  import SelectImage from '@/components/SelectImage'
  import Allergens from './Allergens'
  import FoodDrinkExtrasForm from '../../../../dishOrders/foodDrinkExtrasForm/Index'
  export default {
    components: {
      Translate,
      SelectImage,
      Allergens,
      FoodDrinkExtrasForm,
    },
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
      showExtras: false,
    }),
    computed: {
      ...mapState('app',['collapseContent', 'locale']),
      languages () {
        return this.$store.state.app.Languages
      },
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      name () {
        const limit = 20
        const aux = this.content.FoodName ? utils.getTranslation (this.content.FoodName, this.locale) : ''
        return aux ? aux.substring(0, limit).concat(aux.length > limit ? '...' : '' ) : ''
      }
    },
    mounted () {
      this.checkShowExtras() 
    },
    methods: {
      checkShowExtras () {
        apiDishOrders.getShowExtras() 
          .then(response => {
            response = response.shift()
            this.showExtras = response && response.IncludeExtras ? true : false
          })
      },
      handleChangeIsModified () {
        this.$store.state.app.isModified = true
      },
      handleChangeExtraConfigLocal (labelExtra, onlyOne) {
        this.content.FoodLabelExtras = labelExtra
        this.content.FoodOnlyOne = onlyOne
        this.handleChangeIsModified()
      },
    }
  }
</script>

<style scoped>
</style>

